import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Tabs } from 'antd';

import SearchUser from '@comm/SearchUser';
import { getAccountSearch } from '@store/modules/core_account_search';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';
import Activity from './Activity';
import ActivityAdd from './ActivityAdd';

const FormItem = Form.Item;
const { TabPane } = Tabs;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      currentActivity: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(getAccountSearch());
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const permis = this.props.form.getFieldsValue();
    if (data && data.uuid) {
      permis.uuid = data.uuid;
    }
    permis.activities = data.activities;
    this.props.form.validateFields(err => {
      if (!err) {
        // TODO 需要处理数据
        handSubmit(permis);
      }
    });
  };

  callback = () => {};

  showDrawer = activity => {
    // TODO 显示活动内容
    this.setState({
      visible: true,
      currentActivity: activity,
    });
  };

  closeDrawer = () => {
    this.setState({
      visible: false,
    });
  };

  deleteActivity = activity => {
    const { data } = this.props;
    const activities = data.activities ? data.activities : [];
    data.activities = activities.filter(form => form.index !== activity.index);
    this.setState({}, this.closeDrawer());
  };

  addActivity = activity => {
    // TODO 辨别是否已将存在
    if (activity !== undefined) {
      const { data } = this.props;
      let activities = data.activities ? data.activities : [];
      let flag = false;
      const index = 0;
      activities = activities.map(form => {
        if (form.index === activity.index) {
          flag = true;
          return activity;
        }
        return form;
      });
      if (!flag) {
        activity.index = index + 1;
        activities.push(activity);
      }
      data.activities = activities;
      this.setState({}, this.closeDrawer());
    }
  };

  onChangeProcessor = () => {};

  render() {
    const { getFieldDecorator } = this.props.form;

    const dataItem = this.props.data;
    const activities = dataItem.activities ? dataItem.activities : [];
    const listActities = activities.map(activity => {
      return (
        <Activity
          activity={activity}
          key={activity.uuid}
          showDrawer={current => {
            this.showDrawer(current);
          }}
        />
      );
    });
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };

    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <Button icon="save" style={{ marginRight: 10 }} htmlType="submit">
            保存
          </Button>
        </div>

        <Tabs defaultActiveKey="1" onChange={this.callback}>
          <TabPane tab="基础设置" key="1">
            <Card>
              <Row>
                <Col span={20}>
                  <FormItem label="工作流模板名称" {...ItemLayout}>
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: '请输入名称 !' }],
                      initialValue: dataItem.name ? dataItem.name : '',
                    })(<Input placeholder="工作流模板名称" />)}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={20}>
                  <FormItem label="工作流模板标识" {...ItemLayout}>
                    {getFieldDecorator('sign', {
                      rules: [{ required: true, message: '请输入标识 !' }],
                      initialValue: dataItem.sign ? dataItem.sign : '',
                    })(<Input placeholder="工作流模板标识" />)}
                  </FormItem>
                </Col>
              </Row>
            </Card>
          </TabPane>
          <TabPane tab="流程设计" key="2">
            <Card title="默认审批流程">
              <Row>
                <Col span={20}>
                  <FormItem label="默认审批人" {...ItemLayout}>
                    {listActities}
                    <Button
                      type="primary"
                      shape="circle"
                      icon="plus"
                      onClick={() => this.showDrawer({})}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={20}>
                  <FormItem label="默认抄送人" {...ItemLayout}>
                    {getFieldDecorator('cc', {
                      initialValue: dataItem.cc ? dataItem.cc : '',
                    })(<SearchUser />)}
                  </FormItem>
                </Col>
              </Row>
            </Card>
            {this.state.visible ? (
              <ActivityAdd
                ref={form => {
                  this.form = form;
                }}
                activity={this.state.currentActivity}
                closeDrawer={() => this.closeDrawer()}
                deleteActivity={activity => this.deleteActivity(activity)}
                addActivity={activity => this.addActivity(activity)}
                getFieldDecorator={getFieldDecorator}
                visible={this.state.visible}
              />
            ) : null}
          </TabPane>
        </Tabs>
      </Form>
    );
  }
}

export default connect(state => state)(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/boss/workflow/template/BaseForm.js